import { useState } from "react";
import { useScheduledRunsQuery } from "hooks/queries/useScheduledRunsQuery";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip
} from "@mui/material";
import { SettingsSection } from "components/Settings/SettingsSection";
import { styled } from "@mui/material/styles";
import { useLoadCounter } from "hooks/useLoadCounter";

export const EmailScheduleRunTable = (): JSX.Element => {
  const [isTruncatedMap, setIsTruncatedMap] = useState<Record<number, boolean>>(
    {}
  );

  const {
    isLoading: scheduledRunsLoading,
    error: scheduledRunsError,
    data: scheduledRuns
  } = useScheduledRunsQuery({ pageSize: 50 });
  const tableLoadCount = useLoadCounter(scheduledRunsLoading);

  const handleMouseOver = (
    event: React.MouseEvent<HTMLTableCellElement>,
    id: number
  ): void => {
    const isTruncated =
      event.currentTarget.offsetWidth < event.currentTarget.scrollWidth;
    setIsTruncatedMap({
      ...isTruncatedMap,
      [id]: isTruncated
    });
  };

  if (scheduledRunsError) {
    return <div>Error getting scheduled runs. </div>;
  }

  if (scheduledRunsLoading) {
    return <div>Loading...</div>;
  }

  return (
    <SettingsSection title="Scheduled Summary Email Runs">
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell data-col={1}>Id</TableCell>
              <TableCell data-col={2}>Last Run Date</TableCell>
              <TableCell data-col={3}>Status</TableCell>
              <TableCell data-col={4}>Error Message</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            data-qa_loading={scheduledRunsLoading}
            data-qa_load_count={tableLoadCount}
          >
            {scheduledRuns?.results?.map(record => {
              const isTruncated = isTruncatedMap[record.id] || false;
              return (
                <TableRow key={record.id}>
                  <TableCell data-col={1}>{record.id}</TableCell>
                  <TableCell data-col={2}>{record.run_date}</TableCell>
                  <TableCell data-col={3}>{record.status}</TableCell>
                  <Tooltip
                    title={
                      isTruncated && record.error_message
                        ? record.error_message
                        : ""
                    }
                  >
                    <StyledTableCell
                      data-col={4}
                      onMouseOver={(
                        event: React.MouseEvent<
                          HTMLTableCellElement,
                          MouseEvent
                        >
                      ) => handleMouseOver(event, record.id)}
                    >
                      {record.error_message}
                    </StyledTableCell>
                  </Tooltip>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </SettingsSection>
  );
};

const StyledTableCell = styled(TableCell)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 300px;
`;
